import { render } from "./MakeOperation.vue?vue&type=template&id=045f064f"
import script from "./MakeOperation.vue?vue&type=script&lang=js"
export * from "./MakeOperation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__